// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__3YGBK","buttons":"RemoveExpirationActionButtons_buttons__20ZnG"};